import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledFiltersGrid = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: minmax(260px, auto) auto minmax(260px, auto);
        gap: ${spacing * 3}px;
    `
)
